// Alina Tselinina: language-independent facts plus one profile file per language.
module.exports = {
  slug: 'alina-tselinina',
  displayName: 'Alina Tselinina',
  name: 'Alina Tselinina',
  pdf: {
    firstName: 'Alina',
    familyName: 'Tselinina',
    email: 'info@paioneer.eu',
    homepage: 'paioneer-labs.eu'
  },
  pages: {
    de: require('./de.cjs'),
    en: require('./en.cjs'),
    nl: require('./nl.cjs'),
    uk: require('./uk.cjs'),
    fr: require('./fr.cjs'),
    it: require('./it.cjs'),
    es: require('./es.cjs'),
    sv: require('./sv.cjs'),
    fi: require('./fi.cjs'),
    ja: require('./ja.cjs'),
    pl: require('./pl.cjs'),
    bg: require('./bg.cjs')
  }
};
